export default __webpack_public_path__ + "static/media/poppy_case_study_hero.png.webp";